(function () {
  'use strict';
  angular
    .module('com.module.authproviders')
    .run(function ($rootScope, gettextCatalog) {
        
    });

})();
